var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(":(")]),_c('div',[_vm._v("Es konnte keine Verbindung zur Datenbank hergestellt werden")])])
}]

export { render, staticRenderFns }